import { Input } from '@/src/common/components/Input'
import Feather from '@expo/vector-icons/Feather'
import { type ComponentProps, useEffect, useState } from 'react'
import { useDebounce } from 'tamagui'

interface SearchBarProps extends ComponentProps<typeof Input> {
  onSearch: (query: string) => void
  placeholder?: string
  debounceOptions?: {
    wait?: Parameters<typeof useDebounce>[1]
    debounceSettings?: Parameters<typeof useDebounce>[2]
    mountArgs?: Parameters<typeof useDebounce>[3]
  }
}

export default function SearchBar({
  onSearch,
  placeholder = 'Search',
  debounceOptions = {
    wait: 500,
    debounceSettings: { leading: false },
    mountArgs: [],
  },
  ...props
}: SearchBarProps) {
  const [searchQuery, setSearchQuery] = useState('')

  const debouncedSearch = useDebounce(
    onSearch,
    debounceOptions.wait ?? 500,
    debounceOptions.debounceSettings,
    debounceOptions.mountArgs,
  )

  useEffect(() => {
    debouncedSearch(searchQuery)
  }, [debouncedSearch, searchQuery])

  return (
    <Input
      placeholder={placeholder}
      value={searchQuery}
      onChangeText={setSearchQuery}
      leftIcon={<Feather name="search" size={16} color="black" />}
      leftIconContainerStyle={{ marginLeft: 16 }}
      inputContainerStyle={{ borderRadius: 9999, backgroundColor: '#F4F6F7' }}
      {...props}
    />
  )
}
